module.exports = __webpack_public_path__ + "img/full5-min.6116894e.png";